import { render, staticRenderFns } from "./noticeDetailPop.vue?vue&type=template&id=1d69af78&scoped=true"
import script from "./noticeDetailPop.vue?vue&type=script&lang=js"
export * from "./noticeDetailPop.vue?vue&type=script&lang=js"
import style0 from "./noticeDetailPop.vue?vue&type=style&index=0&id=1d69af78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d69af78",
  null
  
)

export default component.exports